import * as constants from '../constants/constants';

export const openRecipeModal = (modalRecipeData) => {
  return {
    type: constants.OPEN_RECIPE_MODAL,
    payload: {
      modalRecipeData,
    },
  };
};

export const closeRecipeModal = () => {
  return {
    type: constants.CLOSE_RECIPE_MODAL,
  };
};



// WEBPACK FOOTER //
// ./src/actions/recipeModal.js